export default class ModeloDeTarefaModel {
  constructor() {
    this.id = '';
    this.nome = '';
    this.padrao = false;
    this.geraMulta = false;
    this.responsavelId = '';
    this.departamentoId = '';
    this.departamentoPadraoId = '';
    this.descricao = '';
    this.sistemaProprietario = 1;
    this.complementoTemplate = {};
    this.complementoTemplate.fasesTemplates = null;
    this.camposEditaveisPadrao = null;
  }
}
